"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M18.345 12.689A5.662 5.662 0 0 1 24 18.345a5.662 5.662 0 0 1-5.439 5.65l-.216.005H5.655A5.662 5.662 0 0 1 0 18.345a5.663 5.663 0 0 1 5.44-5.652l.216-.004h12.689Zm0 1H5.655A4.661 4.661 0 0 0 1 18.345a4.661 4.661 0 0 0 4.443 4.65l.213.005h12.689A4.66 4.66 0 0 0 23 18.345a4.66 4.66 0 0 0-4.442-4.651l-.213-.005Zm-2.317 2.34a3.28 3.28 0 0 1 4.633 0 3.28 3.28 0 0 1 0 4.632 3.265 3.265 0 0 1-2.316.958 3.266 3.266 0 0 1-2.317-.958 3.28 3.28 0 0 1 0-4.633Zm2.317.041a2.273 2.273 0 0 0-1.61 3.884 2.28 2.28 0 0 0 3.22 0 2.278 2.278 0 0 0 0-3.219 2.269 2.269 0 0 0-1.61-.665Zm0-16.07A5.662 5.662 0 0 1 24 5.655a5.663 5.663 0 0 1-5.439 5.652l-.217.004H5.655A5.662 5.662 0 0 1 0 5.655 5.662 5.662 0 0 1 5.44.005L5.655 0h12.69Zm0 1H5.654A4.66 4.66 0 0 0 1 5.655a4.661 4.661 0 0 0 4.443 4.651l.212.005h12.69A4.661 4.661 0 0 0 23 5.655a4.66 4.66 0 0 0-4.443-4.65L18.344 1ZM3.338 3.339a3.28 3.28 0 0 1 4.633 0 3.28 3.28 0 0 1 0 4.633 3.27 3.27 0 0 1-2.317.958 3.27 3.27 0 0 1-2.316-.958 3.28 3.28 0 0 1 0-4.633Zm2.316.04c-.583 0-1.165.223-1.609.667a2.28 2.28 0 0 0 0 3.219 2.28 2.28 0 0 0 3.219 0 2.28 2.28 0 0 0 0-3.22 2.27 2.27 0 0 0-1.61-.665Z",
    clipRule: "evenodd"
  })]
});